export const SET_PROFILES = "SET_PROFILES";
export const ADD_PROFILE_TO_LIST = "ADD_PROFILE_TO_LIST";
export const SET_PROFILE = "SET_PROFILE";
export const REMOVE_PROFILE = "REMOVE_PROFILE";
export const ADD_NEW_PROFILE = "ADD_NEW_PROFILE";
export const UPDATE_STATE_USER = "UPDATE_STATE_USER";
export const SET_ALL_PROFILES = "SET_ALL_PROFILES";
